import './i18n';
import ReactDOM from 'react-dom/client';
//import './index.css';
import App from './App';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import '../src/styles/global.css';

// pages
import HomeWedding from "./pages/Home";
import Home1 from './pages/Home1';
import Register from './pages/Register';
import Login from './pages/Login';
import ForgotPasswordPage from './pages/ForgotPassword';
import AdminOrganizationPage from './pages/AdminOrganizationPage';
import GuestReservationPage from './pages/GuestReservationPage';
import TermsPage from './pages/TermsPage';
import PrivacyPage from './pages/PrivacyPage';
import SuccessPageStripe from './pages/SuccessPageStripe';
import CancelPageStripe from './pages/CancelPageStripe';
import NotFoundPage from './pages/NotFoundPage';
import Pricing from './pages/Pricing';
import Preview from './pages/Preview';
import WeddinfyIG1 from './components/WeddinfyIG1';
import WeddinfyIG2 from './components/WeddinfyIG2';
import WeddinfyIG3 from './components/WeddinfyIG3';
import SuperAdminDashboard from './pages/SuperAdminDashboard';
import AuthGuardingSuperAdmin from './utils/AuthGuardingSuperAdmin';

import { Provider } from 'react-redux';
import store from './store/store';

import AuthGuardingAdmin from './utils/AuthGuardingAdmin';
import RequireServer from './utils/RequireServer';

const router = createBrowserRouter([{
    path: "/",
    element: <App />,
    errorElement: <div>ERROR PAGE 404</div>,
    children: [
        {
            path: "/",
            element: <HomeWedding />
        },
        {
            path: "/1",
            element: <Home1 />
        },
        {
            path: "/register",
            element: <Register />
        },
        {
            path: "/login",
            element: <Login />
        },
        {
            path: "/forgot-password",
            element: <ForgotPasswordPage />
        },
        {
            path: "/organization",
            element:
                <AuthGuardingAdmin >
                    <AdminOrganizationPage />
                </AuthGuardingAdmin >
        },
        {
            path: "/organization/:weddingId/:code",
            element:
                <RequireServer>
                    <GuestReservationPage />
                </RequireServer>
        },
        {
            path: "/terms",
            element: <TermsPage />
        },
        {
            path: "/privacy",
            element: <PrivacyPage />
        },
        {
            path: "/super-admin",
            element:
                <AuthGuardingSuperAdmin>
                    <SuperAdminDashboard />
                </AuthGuardingSuperAdmin>
        },
        {
            path: "/success",
            element: <SuccessPageStripe />
        },
        {
            path: "/cancel",
            element: <CancelPageStripe />
        },
        {
            path: "/pricing",
            element: <Pricing />
        },
        {
            path: "/preview1",
            element: <Preview />
        },
        {
            path: "*",
            element: <NotFoundPage />
        },
        // {
        //     path: "/ig-1",
        //     element: <WeddinfyIG1 />
        // },
        // {
        //     path: "/ig-2",
        //     element: <WeddinfyIG2 />
        // },
        // {
        //     path: "/ig-3",
        //     element: <WeddinfyIG3 />
        // }
    ]
}])

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    // <React.StrictMode>
    <Provider store={store}>
        <RouterProvider router={router} />
    </Provider>
    // </React.StrictMode>
);
